import { render } from "./AssignedResourcesChips.vue?vue&type=template&id=babe52cc"
import script from "./AssignedResourcesChips.vue?vue&type=script&lang=js"
export * from "./AssignedResourcesChips.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./AssignedResourcesChips.vue?vue&type=style&index=0&id=babe52cc&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__